import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZModbusParameterDetails = z.object({
  readingTime: z.string(),
  value: z.number(),
  indexValue: z.number(),
  registerName: z.string(),
  units: z.string().nullable()
})

export const ZData = z.object({
  assetId: z.string(),
  total_count: z.number(),
  assetRegisterData: ZModbusParameterDetails.array()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.optional(ZData)
})

export type ModbustListDetails = z.infer<typeof ZModbusParameterDetails>
export type ModbusParameterAPIData = z.infer<typeof ZApiResponse>

export async function getModbuParamterData (
  assetId: string,
  assetTypeId: string,
  onSuccess: (ModbusParamterData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/register/tiqGetRegisterReadings?assetId=${assetId}&assetTypeId=${assetTypeId}`
  /* eslint-disable @typescript-eslint/return-await */
  return interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
